export const actions = {
  TRADUCCIONES_PAGINA_LOAD_REQUESTED: 'TRADUCCIONES_PAGINA_LOAD_REQUESTED',
  TRADUCCIONES_PAGINA_LOAD_SUCCEEDED: 'TRADUCCIONES_PAGINA_LOAD_SUCCEEDED',
  TRADUCCIONES_PAGINA_LOAD_FILED: 'TRADUCCIONES_PAGINA_LOAD_FILED',

  TRADUCCION_PAGINA_UPDATE_REQUESTED: 'TRADUCCION_PAGINA_UPDATE_REQUESTED',
  TRADUCCION_PAGINA_UPDATE_SUCCEEDED: 'TRADUCCION_PAGINA_UPDATE_SUCCEEDED',
  TRADUCCION_PAGINA_UPDATE_FILED: 'TRADUCCION_PAGINA_UPDATE_FILED',

  TRADUCCION_PAGINA_INSERT_REQUESTED: 'TRADUCCION_PAGINA_INSERT_REQUESTED',
  TRADUCCION_PAGINA_INSERT_SUCCEEDED: 'TRADUCCION_PAGINA_INSERT_SUCCEEDED',
  TRADUCCION_PAGINA_INSERT_FILED: 'TRADUCCION_PAGINA_INSERT_FILED',

  TRADUCCION_PAGINA_DELETE_REQUESTED: 'TRADUCCION_PAGINA_DELETE_REQUESTED',
  TRADUCCION_PAGINA_DELETE_SUCCEEDED: 'TRADUCCION_PAGINA_DELETE_SUCCEEDED',
  TRADUCCION_PAGINA_DELETE_FILED: 'TRADUCCION_PAGINA_DELETE_FILED',

  TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_REQUESTED: 'TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_REQUESTED',
  TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_SUCCEEDED: 'TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_SUCCEEDED',
  TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_FILED: 'TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_FILED',

  TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_INSERT_REQUESTED:
    'TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_INSERT_REQUESTED',
}

export const getTraduccionesPaginaAction = dispatch => {
  dispatch({
    type: actions.TRADUCCIONES_PAGINA_LOAD_REQUESTED,
  })
}

export const onSubmitInsertTraduccionPaginaFormAction = (dispatch, formTraduccionPagina) => {
  dispatch({
    type: actions.TRADUCCION_PAGINA_INSERT_REQUESTED,
    payload: formTraduccionPagina,
  })
}

export const onSubmitUpdateTraduccionPaginaFormAction = (dispatch, formTraduccionPagina) => {
  dispatch({
    type: actions.TRADUCCION_PAGINA_UPDATE_REQUESTED,
    payload: formTraduccionPagina,
  })
}

export const deleteTraduccionPaginaAction = (dispatch, id) => {
  dispatch({
    type: actions.TRADUCCION_PAGINA_DELETE_REQUESTED,
    payload: id,
  })
}

export const getTraduccionUrlCreateEditByTipoIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_INSERT_REQUESTED,
    })
  }
}
